import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd-mobile';
import TermsOfService from '../../../component/documents/terms-of-service';
import PrivacyPolicy from '../../../component/documents/privacy-plicy';

const tabs = [
    { title: '用户服务协议' },
    { title: '隐私政策' }
];

function ModalComponent(props: any) {
    return (
        <div style={{height: 500, padding: '0 5px'}}>
            <Tabs tabs={tabs} initialPage={props.type == 'agreement' ? 0 : 1} tabBarUnderlineStyle={{ display: 'none' }}>
                <TermsOfService/>
                <PrivacyPolicy/>
            </Tabs>
        </div>
    )

}

export default ModalComponent;